import { createContext, useContext } from 'react';

/**
 * Shared light/dark mode state. App.jsx owns the state (and drives both the MUI
 * theme palette AND the CSS-variable `data-theme` attribute from it); ThemeToggle
 * consumes this to read `mode` and flip it. Kept in its own file so ThemeToggle
 * doesn't import App.jsx (which would be a circular dependency).
 */
export const ThemeModeContext = createContext({ mode: 'light', toggleMode: () => {} });

export const useThemeMode = () => useContext(ThemeModeContext);
